import React from "react"
import styles from "./Messages.module.scss"


export const MessageLG:React.FC<{text:string}> = ({text}) => <span className={styles.lg}>{text}</span>
export const MessageSM:React.FC<{text:string}> = ({text}) => <span className={styles.sm}>{text}</span>

export const MessageDisplayLG:React.FC<{text:string}> = ({text}) => <span className={styles.displayLg}>{text}</span>
export const MessageDisplaySM:React.FC<{text:string}> = ({text}) => <span className={styles.displaySm}>{text}</span>
